import script from "./BaseDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseDialog.vue?vue&type=script&setup=true&lang=ts"

import "./BaseDialog.vue?vue&type=style&index=0&id=7b45d624&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b45d624"]])

export default __exports__